<template>
    <div class="row">
        <div @click="showModal" class="col-12 staff-member">
            <img :src="image" class="img-fluid" />
        </div>

        <sweet-modal
                ref="modal"
                :width="width()"
        >
            <div class="row">
                <div class="col-12 col-md-4 col-lg-6">
                    <img :src="image" class="img-fluid" :alt="alt" :title="alt" />
                </div>
                <div class="col-12 col-md-8 col-lg-6 text-left">
                    <div class="pl-3">
                        <slot></slot>
                    </div>
                </div>
            </div>
        </sweet-modal>
    </div>
</template>

<script>
    import { SweetModal } from 'sweet-modal-vue';
    import { vueWindowSizeMixin } from 'vue-window-size';

    export default {
        name: "StaffMember",
        mixins: [
            vueWindowSizeMixin
        ],
        components: {
            SweetModal
        },
        props: {
            image: String,
            name: String
        },
        computed: {
            alt() {
                return `${name} profile photo`
            }
        },
        methods: {
            showModal() {
                this.$refs.modal.open()
            },

            width() {
                if (this.windowWidth >= 600 && this.windowWidth < 768) {
                    return 500;
                } else if (this.windowWidth >= 768 && this.windowWidth < 1023) {
                    return 700;
                } else if (this.windowWidth >= 1024 && this.windowWidth < 1300) {
                    return 900;
                } else if (this.windowWidth >= 1300) {
                    return 1100;
                } else {
                    return '100%';
                }
            }
        }
    }
</script>

<style scoped>

</style>